import { createComputed, createSignal, on } from "solid-js"
import { SelectedToolId } from "../../lib/core/map_editor/SelectedToolId.enum"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

// type EngineTool = null | any | unknown
type EngineTool = SelectedToolId

const DEBUG_THROW_IF_BAD_TOOL_CHANGE = false

/**
 * example usage:
 * export const [getSelectedTool, setSelectedTool] = useSelectedToolSignal(engine)
 */
export const useSelectedToolSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<EngineTool>(SelectedToolId.Inspect)

  if (DEBUG_THROW_IF_BAD_TOOL_CHANGE) {
    createComputed(on(signal[0],(newSelectedToolId, prevSelectedToolId) => {
      console.log('getSelectedTool', {newSelectedToolId, prevSelectedToolId})
      if (newSelectedToolId === SelectedToolId.Inspect && prevSelectedToolId === SelectedToolId.Elevation) {
        throw new Error('not expected')
      }
    }))
  }

  return signal
})


